import React from 'react'

const Results = data => (
  <tbody>
  {data.results}
  </tbody>
)

export default Results



// WEBPACK FOOTER //
// ./src/components/GmBlockingThreshold/Results.js